module.exports = __webpack_public_path__ + "img/phone.66a618cf.svg";